import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer
} from 'recharts';
import { colors } from '../../brand-colors';

/**
 * Email Effectiveness Chart - Bar showing Opens, Clicks, Purchases
 */
function EmailEffectivenessChart({ data }) {
  if (!data || (data.opens === 0 && data.clicks === 0 && data.purchases === 0)) {
    return (
      <div style={styles.placeholder}>
        <p>No email data available</p>
        <small>Connect GHL to see email stats</small>
      </div>
    );
  }

  const chartData = [
    { name: 'Opens', value: data.opens || 0 },
    { name: 'Clicks', value: data.clicks || 0 },
    { name: 'Purchases', value: data.purchases || 0 }
  ];

  // Calculate rates for tooltip
  const openRate = data.opens > 0 ? ((data.clicks / data.opens) * 100).toFixed(1) : 0;
  const conversionRate = data.clicks > 0 ? ((data.purchases / data.clicks) * 100).toFixed(1) : 0;

  return (
    <div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 10, right: 30, left: 60, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis
            type="number"
            tick={{ fill: colors.grey, fontSize: 12 }}
          />
          <YAxis
            type="category"
            dataKey="name"
            tick={{ fill: colors.grey, fontSize: 12 }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #e0e0e0',
              color: colors.greyDarkest
            }}
            formatter={(value) => [value.toLocaleString(), '']}
          />
          <Bar
            dataKey="value"
            fill={colors.teal}
            radius={[0, 4, 4, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
      <div style={styles.stats}>
        <span>Click Rate: {openRate}%</span>
        <span>Conversion: {conversionRate}%</span>
      </div>
    </div>
  );
}

const styles = {
  placeholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 250,
    color: colors.greyMid,
    textAlign: 'center'
  },
  stats: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: 10,
    fontSize: 12,
    color: colors.grey
  }
};

export default EmailEffectivenessChart;
